import {GridRows as VisxGridRows} from '@visx/grid';
import {GridScale} from '@visx/grid/lib/types';
import React, {FC} from 'react';

import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';

interface GridRowsProps {
  width: number;
  scale: GridScale;
  numTicks?: number;
}

export const GridRows: FC<GridRowsProps> = ({width, scale, numTicks}) => {
  const theme = useUserTheme();

  return (
    <VisxGridRows
      width={width}
      scale={scale}
      stroke={theme.greys.shade30}
      strokeWidth={1}
      numTicks={numTicks}
      strokeDasharray="3,3"
    />
  );
};
